import React from 'react';

import {
  STATUS_DELIVERED,
  STATUS_PREPARING,
  STATUS_CANCELLED,
} from 'src/consts/ORDER_STATUS';

import BillPlaceholder from './BillPlaceholder';

import BillPreparing from 'src/components/BillPreparing';
import BillDelivered from 'src/components/BillDelivered';
import BillCancelled from 'src/components/BillCancelled';

export default function BillEntry({ entry }) {
  if (entry) {
    switch (entry.status) {
      case STATUS_PREPARING:
        return <BillPreparing entry={entry} />;

      case STATUS_DELIVERED:
        return <BillDelivered entry={entry} />;

      case STATUS_CANCELLED:
        return <BillCancelled entry={entry} />;

      default:
        return <BillPlaceholder />;
    }
  } else {
    return <></>;
  }
}
